'use client';

import React from 'react';
import { MenuSection, MenuItem } from '@/types';
import MenuSectionRenderer from './MenuSectionRenderer';
import { useVideoLoading } from '@/contexts/MediaContext';
import DeferredContent from './DeferredContent';
import { PublicFormData, PublicPolicyData } from '@/lib/public-site-data';

interface MenuSectionsRendererProps {
  header?: MenuSection;
  footer?: MenuSection;
  menuItems?: MenuItem[];
  subscriptionForm?: PublicFormData | null;
  policies?: PublicPolicyData[];
}

export default function MenuSectionsRenderer({
  header,
  footer,
  menuItems,
  subscriptionForm = null,
  policies = [],
}: MenuSectionsRendererProps) {
  const { videosLoaded } = useVideoLoading();

  // Render header immediately, footer can wait for videos if needed
  return (
    <>
      {/* Header renders immediately - no waiting for videos */}
      {header && (
        <MenuSectionRenderer
          menuSection={header}
          menuItems={menuItems}
          footerMenuSection={footer}
          subscriptionForm={subscriptionForm}
        />
      )}
      {/* Footer renders after videos load */}
      {footer && videosLoaded && (
        <DeferredContent delay={100}>
          <MenuSectionRenderer
            menuSection={footer}
            menuItems={menuItems}
            subscriptionForm={subscriptionForm}
            policies={policies}
          />
        </DeferredContent>
      )}
    </>
  );
}
